<template>
  <div id="users-wrapper">
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  mounted () { },
  methods: {},
  computed: {
  }
}
</script>
<style lang="scss" scoped>
</style>
